import { motion } from 'framer-motion';
import ContactForm from '../components/Contact/ContactForm';
const Contact = () => {
  return (
    <div className="min-h-screen">
      <div className="min-h-screen flex flex-col md:flex-row">
        {/* Left half - Form */}
        <div className="w-full md:w-1/2 bg-white p-6 md:p-12 flex items-center">
          <div className="w-full max-w-xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="mb-8 md:mb-12"
            >
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Contact our sales team
              </h1>
              <p className="text-lg text-gray-600">
                Fill out the form below and we'll get back to you shortly.
              </p>
            </motion.div>
            <ContactForm />
          </div>
        </div>

        {/* Right half - Illustration (hidden on mobile) */}
        <div className="hidden md:flex w-full md:w-1/2 bg-[#F8FAFF] items-center justify-center p-12">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2 }}
            className="w-full max-w-2xl"
          >
            <img
              src="/assets/images/contact-illustration.svg"
              alt="Contact illustration"
              className="w-full h-auto"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 